<section>
  <ng-container *ngIf="isLoading; else loadedTemplate">
    <app-loading [onlyIcon]="true"></app-loading>
  </ng-container>
  <ng-template #loadedTemplate>
    <div class="new-contracts">
      <h2 class="new-contracts-title">{{ 'NEW_CONTRACTS.TITLE' | i18nextEager }}</h2>
      <div class="new-contracts-resume">
        <div>
          <h3>{{ 'NEW_CONTRACTS.DRAFT' | i18nextEager }}</h3>
          <h4>{{ numBorrador }}</h4>
        </div>
        <div>
          <h3>{{ 'NEW_CONTRACTS.PENDING_DIGITAL_SIGN' | i18nextEager }}</h3>
          <h4>{{ numPendienteFirma }}</h4>
        </div>
        <div>
          <h3>{{ 'NEW_CONTRACTS.INCIDENCE' | i18nextEager }}</h3>
          <h4>{{ numIncidencia }}</h4>
        </div>
        <div>
          <h3>{{ 'NEW_CONTRACTS.ACCIONA_REJECTION' | i18nextEager }}</h3>
          <h4>{{ numRechazoAcciona }}</h4>
        </div>
        <div>
          <h3>{{ 'NEW_CONTRACTS.ATR_REJECTION' | i18nextEager }}</h3>
          <h4>{{ numRachazoAtr }}</h4>
        </div>
      </div>
      <img class="new-contracts-goTo" src="/assets/icons/arrow.svg" alt="Arrow" (click)="handleNavigate()" />
      <app-table
        class="new-contracts-table"
        [data]="contratos"
        [colsTable]="colsTable"
        (clickButton)="handleButton($event)"
      ></app-table>
    </div>
  </ng-template>
</section>
